import { render, staticRenderFns } from "./chance.vue?vue&type=template&id=f0360854&scoped=true&"
import script from "./chance.vue?vue&type=script&lang=js&"
export * from "./chance.vue?vue&type=script&lang=js&"
import style0 from "./chance.vue?vue&type=style&index=0&id=f0360854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0360854",
  null
  
)

export default component.exports